var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAnalyteExplorerWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "202px",
    height: "119px",
    viewBox: "0 0 202 119",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Analyte Explorer Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-145.000000, -496.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "analyte_exp",
    transform: "translate(145.000000, 496.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 0,
    y: 0,
    width: 202,
    height: 119
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(27.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,13.5014153 C18,15.4346947 16.4318641,17 14.4985847,17 C12.5681359,17 11,15.4346947 11,13.5014153 C11,11.5681359 12.5681359,10 14.4985847,10 C16.4318641,10 18,11.5681359 18,13.5014153",
    id: "Fill-1",
    fill: "#0F91F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,13.5014153 C31,15.4346947 29.4318641,17 27.4985847,17 C25.5681359,17 24,15.4346947 24,13.5014153 C24,11.5681359 25.5681359,10 27.4985847,10 C29.4318641,10 31,11.5681359 31,13.5014153",
    id: "Fill-3",
    fill: "#0F91F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,13.5014153 C44,15.4346947 42.4318641,17 40.5014153,17 C38.5681359,17 37,15.4346947 37,13.5014153 C37,11.5681359 38.5681359,10 40.5014153,10 C42.4318641,10 44,11.5681359 44,13.5014153",
    id: "Fill-5",
    fill: "#FF5B00"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-9",
    stroke: "#0F91F2",
    strokeWidth: 4.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "140 96 0 96 0 0 140 0 140 36.4142895"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 26,
    x2: 140,
    y2: 26,
    id: "Stroke-11",
    stroke: "#0F91F2",
    strokeWidth: 4.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 26,
    x2: 37,
    y2: 96,
    id: "Path-5",
    stroke: "#0F91F2",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 39,
    x2: 7.72393057,
    y2: 39,
    id: "Path-6",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 48,
    x2: 7.72393057,
    y2: 48,
    id: "Path-6-Copy",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 68,
    x2: 7.72393057,
    y2: 68,
    id: "Path-6-Copy-2",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 76,
    x2: 7.72393057,
    y2: 76,
    id: "Path-6-Copy-3",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 85,
    x2: 7.72393057,
    y2: 85,
    id: "Path-6-Copy-4",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 26,
    x2: 37,
    y2: 96,
    id: "Path-5",
    stroke: "#0F91F2",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-7",
    stroke: "#FF5B00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "40.5 58.9865344 56.0952527 43 70.0659248 64.7044823 87.8721433 54.0454545 133.091013 54.0454545"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-8",
    stroke: "#FF5B00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "41.0528894 60.1396877 52.4349236 72.8547906 70.5558194 43 84.824146 66.8 131.545806 54.2700767"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalyteExplorerWhite);
export default __webpack_public_path__ + "static/media/icon-analyte-explorer-white.66b2f003.svg";
export { ForwardRef as ReactComponent };